import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { GoogleAnalytics } from '@grandvisionhq/analytics';
import { Selectors, Utils, Actions } from '@grandvisionhq/auth';
import { Context } from '@grandvisionhq/carts-v2';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { mapPaymentDetailsForOrder } from '../../mappers/data/payment-details-mapper.js';
import { CreateOrderErrors } from '../../mappers/errors-mapping.js';
import { getChangedOptIns, getSelectedDonation, getConsents } from '../../selectors.js';
import { mapConsentsToOrderModel } from '../../utils/map-consent-to-order-model.js';
import '@grandvisionhq/utils';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { useShouldCreateAccount } from '../common/use-should-create-account.js';

const useCreateOrderDraft = ()=>{
    const intl = useIntl();
    const shouldCreateAccount = useShouldCreateAccount();
    const changedOptIns = useSelector(getChangedOptIns);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const selectedDonation = useSelector(getSelectedDonation);
    const { cart  } = Context.useCart();
    const cartRef = React.useRef(cart);
    React.useEffect(()=>{
        cartRef.current = cart;
    }, [
        cart
    ]);
    const optIns = changedOptIns && Utils.createOptInsUpdate(changedOptIns);
    const consents = useSelector(getConsents);
    const { href: callbackHref  } = useLink({
        route: 'auth.callback'
    }) || {};
    const createOrderDraft = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ paymentDetails , selectedPaymentMethod , returnUrl  }) {
            const analyticsId = yield GoogleAnalytics.getAnalyticsId().then((id)=>id
            );
            const mappedConsents = consents && mapConsentsToOrderModel(consents);
            if (isLoggedIn) {
                Actions.OptInsActions.updateOptIns(changedOptIns);
            }
            let loginRedirectUrl;
            if (shouldCreateAccount) {
                const { protocol , host  } = window.location;
                loginRedirectUrl = `${protocol}//${host}${callbackHref}`;
            }
            if (!cartRef.current || !cartRef.current.id) {
                console.error('No Cart');
                throw CreateOrderErrors.ORDER_CREATION_CALL_FAILED;
            }
            const orderDraft = mapPaymentDetailsForOrder({
                intl,
                cartId: cartRef.current.id,
                totalPrice: cartRef.current.prices.totalPrice,
                returnUrl,
                paymentDetails,
                selectedPaymentMethod
            });
            const placeOrderInput = swcHelpers.objectSpread({}, orderDraft, analyticsId ? {
                analyticsId
            } : null, optIns ? {
                optIns
            } : null, loginRedirectUrl ? {
                loginRedirectUrl
            } : null, mappedConsents ? {
                consents: mappedConsents
            } : null, selectedDonation && selectedDonation.amount ? {
                donationIntent: {
                    amount: {
                        centAmount: selectedDonation.amount,
                        currencyCode: intl.currency
                    },
                    foundationKey: selectedDonation.key
                }
            } : null, {
                shouldCreateAccount
            });
            return placeOrderInput;
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        callbackHref,
        changedOptIns,
        consents,
        intl,
        isLoggedIn,
        optIns,
        selectedDonation,
        shouldCreateAccount, 
    ]);
    return createOrderDraft;
};

export { useCreateOrderDraft };
//# sourceMappingURL=use-create-order-draft.js.map
